import { createSlice } from "@reduxjs/toolkit";

const initialState = { showNav: false, selectedNavItem: "dashboard" };
const appSlice = createSlice({
	name: "app",
	initialState,
	reducers: {
		setSelectedNavItem(state, action) {
			state.selectedNavItem = action.payload;
		},
	},
});

export const appActions = appSlice.actions;
export default appSlice;
